import React from 'react';
import AnimatedSection from './AnimatedSection';
import './CloseCTA.css';

const CloseCTA = ({ onContactClick }) => (
  <section className="close-cta section">
    <div className="container">
      <AnimatedSection className="close-cta-inner">
        <p className="section-label">/ Next</p>
        <h2 className="section-title">Have a hard problem?</h2>
        <p className="section-subtitle">
          Tell us what needs to ship. We will tell you if we are the right team —
          and how we would start.
        </p>
        <button type="button" className="btn btn-primary" onClick={onContactClick}>
          Start a conversation
        </button>
      </AnimatedSection>
    </div>
  </section>
);

export default CloseCTA;
